import { text } from "@quickpoint.me/shared";
import { getAuth } from "firebase/auth";
import { useRecoilValue, useSetRecoilState } from "recoil";

import { clearOwnerNameFromSessionStorage } from "../../lib/ownerNameSessionStorage";
import { IsInPortrait } from "../../state/selectors";
import { MousedOverTextHelper } from "../../state/uiAtoms";
import { TopBarControl } from "../StyledControl";

function LogoutControl() {
  const setTextHelper = useSetRecoilState(MousedOverTextHelper);
  const isInPortrait = useRecoilValue(IsInPortrait);

  const signOut = async () => {
    const auth = getAuth();
    await auth.signOut();
    clearOwnerNameFromSessionStorage();
    window.location.reload();
  };

  const mouseOver = () => {
    setTextHelper(text.controls.logout);
  };

  const mouseLeave = () => {
    setTextHelper(undefined);
  };

  return (
    <TopBarControl
      $isInPortrait={isInPortrait}
      className="top-bar-control logout"
      data-testid="logout-control"
      onClick={signOut}
      onMouseOver={mouseOver}
      onMouseLeave={mouseLeave}
    >
      {text.controls.logout}
    </TopBarControl>
  );
}

export default LogoutControl;
